/* AvéliQ fixes v5
   — guarantees the scroll progress bar exists and fills on scroll.
   — collection page: open/close behavior for the design's custom sort
     dropdown (.cl-sort). Options are plain links (?sort_by=), so the
     dropdown only needs toggle + outside-click/Escape close.
   — collection page: chip rail drag-to-scroll safety net + active chip
     brought into view (see bottom).
   The why-grid disc is hidden purely by the cover band's ivory halo (CSS). */
(function () {
  'use strict';

  /* clear any inline opacity left over from the v2 fade */
  var hero = document.querySelector('.why .whyhero');
  if (hero) hero.style.opacity = '';

  function bar() {
    var el = document.getElementById('aq-progress');
    if (!el) {
      el = document.createElement('div');
      el.id = 'aq-progress';
      el.className = 'progressbar';
      document.body.appendChild(el);
    }
    return el;
  }
  function update() {
    ticking = false;
    var de = document.documentElement;
    var sc = window.scrollY || de.scrollTop || 0;
    var max = (de.scrollHeight - de.clientHeight) || 1;
    bar().style.width = (100 * Math.min(1, sc / max)) + '%';
  }
  var ticking = false;
  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('shopify:section:load', onScroll);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
})();

/* ---- collection sort dropdown ---- */
(function () {
  'use strict';

  function wire() {
    document.querySelectorAll('[data-aq-sort]').forEach(function (s) {
      if (s._aqSort) return;
      s._aqSort = true;
      var btn = s.querySelector('.cl-sort__btn');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = s.classList.toggle('open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }
  function closeAll() {
    document.querySelectorAll('[data-aq-sort].open').forEach(function (s) {
      s.classList.remove('open');
      var b = s.querySelector('.cl-sort__btn');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', closeAll);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  document.addEventListener('shopify:section:load', wire);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }
})();

/* ---- collection chip rail (mobile) ----
   Native overflow scrolling does the work; this is the safety net:
   1) drag-to-scroll with pointer events (mouse + any touch stack that
      refuses native panning), 2) scroll the active chip into view on load
      without moving the page vertically. Idempotent; re-runs on section load. */
(function () {
  'use strict';

  function centerActive(rail) {
    var on = rail.querySelector('.chip.on');
    if (!on || rail.scrollWidth <= rail.clientWidth) return;
    var target = on.offsetLeft - (rail.clientWidth - on.offsetWidth) / 2;
    rail.scrollLeft = Math.max(0, Math.min(target, rail.scrollWidth - rail.clientWidth));
  }

  function wire(rail) {
    if (rail._aqRail) return;
    rail._aqRail = true;

    var down = false, moved = false, startX = 0, startLeft = 0, pid = null;

    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      down = true; moved = false; pid = e.pointerId;
      startX = e.clientX; startLeft = rail.scrollLeft;
    });

    rail.addEventListener('pointermove', function (e) {
      if (!down || e.pointerId !== pid) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) < 6) return;
      if (!moved) {
        moved = true;
        rail.classList.add('is-dragging');
        try { rail.setPointerCapture(pid); } catch (err) {}
      }
      rail.scrollLeft = startLeft - dx;
      if (e.pointerType === 'mouse') e.preventDefault();
    });

    function end(e) {
      if (!down) return;
      down = false;
      if (moved) {
        try { rail.releasePointerCapture(pid); } catch (err) {}
        /* swallow the click that would follow a drag */
        var block = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
        rail.addEventListener('click', block, { capture: true, once: true });
        setTimeout(function () { rail.removeEventListener('click', block, { capture: true }); }, 60);
      }
      rail.classList.remove('is-dragging');
      moved = false;
    }
    rail.addEventListener('pointerup', end);
    rail.addEventListener('pointercancel', end);
    rail.addEventListener('lostpointercapture', end);

    centerActive(rail);
  }

  function init() {
    document.querySelectorAll('.cl-filters').forEach(wire);
  }
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('resize', function () {
    document.querySelectorAll('.cl-filters').forEach(centerActive);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
